import React, { FC } from 'react';
import { CarouselProducts, CarouselWithTitle } from './index';
import {
  TypeCarouselFields,
  TypeImage,
  TypeVideo,
} from '@/core/generated-types';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const Carousel: FC<TypeCarouselFields> = (props) => {
  switch (props?.carouselType) {
    case 'carouselSection':
    case 'withTitleAndDescription':
      return <CarouselWithTitle {...props} />;
    case 'products':
      if (!props?.components) return null;

      const components: (TypeVideo | TypeImage)[] = props?.components?.reduce(
        (slides: (TypeVideo | TypeImage)[], curr) => {
          const {
            fields: { component },
          } = curr;

          if (!component) return slides;

          return [...slides, component];
        },
        [],
      );

      if (!components.length) return null;

      return (
        <CarouselProducts
          name={`dynamic carousel - ${props.entryName}`}
          id={props?.id}
          components={components}
        />
      );
    default:
      return null;
  }
};

export default React.memo(Carousel);
